import React from 'react';
import { DollarSign } from 'lucide-react';
import TabComisiones from './tabs/TabComisiones';

export const AnalistaComisionesPage = () => {
  return (
    <div className="px-4 md:px-6 py-4 md:py-6 max-w-screen-2xl mx-auto">
      <TabComisiones />
    </div>
  );
};

export default AnalistaComisionesPage;
